import React, { Component } from 'react';
import { Icon } from 'antd';
import Drag from '@/components/Drag';
import styles from './index.less';

const endDrag = (props, monitor) => {
  const { handleChange } = props;

  if (handleChange) {
    return handleChange(props, monitor);
  }
  return null;
};

class Item extends Component {
  render() {
    const { item, columns } = this.props;

    return (
      <div className="drag-list-column">
        <div className="drag-list-column-icon">
          <Icon type="bars" />
        </div>
        {columns.map(({ dataIndex }) => {
          const val = item[dataIndex];
          if (dataIndex === 'followStatus') {
            return (
              <div
                className={`list-row-item drag-list-column-item table-th-follow-status-${
                  val === 1 ? '1' : '0'
                }`}
              >
                {val === 1 ? '已关注' : '未关注'}
              </div>
            );
          }
          return <div className="list-row-item drag-list-column-item">{val}</div>;
        })}
      </div>
    );
  }
}

export default Drag({ MyComponent: Item, dragSpecAction: { endDrag }, styles });
